import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store/index';
import './registerServiceWorker';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import { fireApp } from './firebase.config';

Vue.config.productionTip = false;
let vueApp: any = null;

fireApp.auth().onAuthStateChanged((user) => {
  store.dispatch('user/setUser', user);

  if (!vueApp) {
    vueApp = new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount('#app');
  }

  if (!user) {
    router.push({name: 'authSignin'});
  } else {
    store.dispatch('carts/loadCarts');
    router.push({name: 'home'});
  }
});

fireApp.firestore().enablePersistence();
